import { ThenEdge } from "@/routes/AutomationEdit/ThenEdge";
import { CreateLeadNode } from "./CreateLeadNode";
import { LivestreamNode } from "./LivestreamNode";
import { MeetingRouteNode } from "./MeetingRouteNode";
import { OnCheckoutSuccessEdge } from "./OnCheckoutSuccessEdge";
import { PageNode } from "./PageNode";
import { StartAutomationNode } from "./StartAutomationNode";
import { SubmitEdge } from "./SubmitEdge";

export const trackNodeTypes = { page: PageNode, createLead: CreateLeadNode };
export const trackEdgeTypes = { submit: SubmitEdge, then: ThenEdge };

export const meetingNodeTypes = {
  meetingRoute: MeetingRouteNode,
  livestream: LivestreamNode,
  startAutomation: StartAutomationNode,
};
export const meetingEdgeTypes = {
  submit: SubmitEdge,
  then: ThenEdge,
  onCheckoutSuccess: OnCheckoutSuccessEdge,
};

/** @deprecated Use trackNodeTypes or meetingNodeTypes */
export const nodeTypes = trackNodeTypes;
/** @deprecated Use trackEdgeTypes or meetingEdgeTypes */
export const edgeTypes = trackEdgeTypes;
